// extracted by mini-css-extract-plugin
export default {"Button":"settings-error-fallback-module__Button--k1B1p"};